import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import swal from "sweetalert";
import "react-dropdown-tree-select/dist/styles.css";
import BackBtn from "../../common/BackBtn";
import { HomeIcon } from "../../assets/Icons";

class EditMcqBank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      question: "",
      alt1: "",
      alt2: "",
      alt3: "",
      correct: "",
      McqTypeBank: "",
      edit_id: 0,
    };
  }
  componentDidMount() {
    var mcq_bank_edit = JSON.parse(sessionStorage.getItem("mcq_bank_edit"));
    this.setState({
      question: mcq_bank_edit.question,
      correct: mcq_bank_edit.correct,
      alt1: mcq_bank_edit.alternative_1,
      alt2: mcq_bank_edit.alternative_2,
      alt3: mcq_bank_edit.alternative_3,
      McqTypeBank: mcq_bank_edit.mcq_type == 1 ? "mcq" : "yesno",
      edit_id: mcq_bank_edit.id,
    });
  }

  onChangeInput = (e) => {
    e.preventDefault();

    this.setState({ [e.target.name]: e.target.value });
  };
  selectedMcqType = (e) => {
    this.setState({ McqTypeBank: e.target.value });
  };

  submit = (e) => {
    var data;
    if (this.state.McqTypeBank === "mcq") {
      data = {
        question: this.state.question,
        correct: this.state.correct,
        alternative_1: this.state.alt1,
        alternative_2: this.state.alt2,
        alternative_3: this.state.alt3,
        mcq_type: 1,
        id: this.state.edit_id,
      };
    } else {
      data = {
        question: this.state.question,
        correct: this.state.correct,
        alternative_1: this.state.alt1,
        mcq_type: 2,
        id: this.state.edit_id,
      };
    }
    if (data.question == "" || data.correct == "" || data.alternative_1 == "") {
      swal("Question, Option 1, and Option 2 are always compulsory..", "", "warning");
      return;
    }
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    let _this = this;
    axios
      .post(`${SERVER_IP}/bank/MCQUpdate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal("Success", response.data.message, "success").then(() => {
              window.location.href = "/create/mcqbanklist";
            } )
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.submit();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };

  render() {
    const { errors } = this.state;
    return (
      <>
        <div class="xp-breadcrumbbar">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <h3 className="xp-page-title pt-3">
                <BackBtn /> MCQ Library
              </h3>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="xp-breadcrumb gradient-border">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <i><HomeIcon/></i>
                    </a>
                  </li>
                  <li
                    class="breadcrumb-item active"
                    onClick={() => (window.location.href = "/create/mcqbanklist")}
                    aria-current="page"
                  >
                    List MCQ Library
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="xp-contentbar p-30">
          <div className="row">
            <div className="col-lg-12">
              <div className="card document_gradient_border padding-0 m-b-30">
                <div className="card-header border-radius-top-15">
                  <h5 className="card-title">Edit MCQ Library</h5>
                </div>
                <div className="card-body">
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label for="exampleInputEmail1">Question</label>
                      <input
                        type="text"
                        onChange={this.onChangeInput}
                        name="question"
                        value={this.state.question}
                        className="form-control"
                        placeholder="Enter Question"
                      />
                    </div>
                  </div>
                  <div className="form-row py-3">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        value="mcq"
                        id="customRadioInline4"
                        name="McqTypeBank"
                        onChange={this.selectedMcqType}
                        class="custom-control-input"
                        checked={this.state.McqTypeBank == "mcq"}
                      />
                      <label class="custom-control-label" for="customRadioInline4">
                        MCQ
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        value="yesno"
                        id="customRadioInline5"
                        name="McqTypeBank"
                        onChange={this.selectedMcqType}
                        class="custom-control-input"
                        checked={this.state.McqTypeBank == "yesno"}
                      />
                      <label class="custom-control-label" for="customRadioInline5">
                        Yes / No
                      </label>
                    </div>

                    {/* <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" value="yesno" id="customRadioInline5no" name="SelectMcqType" onChange={this.selectedMcqType} class="custom-control-input" checked={this.state.SelectMcqType} />
                                            <label class="custom-control-label" for="customRadioInline5no">No</label>
                                        </div> */}
                  </div>
                  {this.state.McqTypeBank != "" ? (
                    <div>
                      <div className="form-row">
                        <div className="form-group col-md-6">
                          <label for="exampleInputEmail1">Option 1 (Correct)</label>
                          <input
                            type="text"
                            onChange={this.onChangeInput}
                            name="correct"
                            value={this.state.correct}
                            className="form-control"
                            placeholder="Enter Correct Answer"
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label for="exampleInputEmail1">Option 2 (Wrong)</label>
                          <input
                            type="text"
                            onChange={this.onChangeInput}
                            name="alt1"
                            value={this.state.alt1}
                            className="form-control"
                            placeholder="Enter Wrong Answer"
                          />
                        </div>
                      </div>

                      {this.state.McqTypeBank === "mcq" ? (
                        <div className="form-row">
                          <div className="form-group col-md-6">
                            <label for="exampleInputEmail1">Option 3 (Wrong)</label>
                            <input
                              type="text"
                              onChange={this.onChangeInput}
                              name="alt2"
                              value={this.state.alt2}
                              className="form-control"
                              placeholder="Enter Wrong Answer"
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label for="exampleInputEmail1">Option 4 (Wrong)</label>
                            <input
                              type="text"
                              onChange={this.onChangeInput}
                              name="alt3"
                              value={this.state.alt3}
                              className="form-control"
                              placeholder="Enter Wrong Answer"
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      <button onClick={this.submit} className="btn btn-primary mt-3">
                        Submit
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default EditMcqBank;
